import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import ProfilePage from './pages/ProfilePage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import Download from './pages/download';
import GuestHeader from './components/GuestHeader';
import UserHeader from './components/UserHeader';
import Footer from './components/Footer';
import Login from './components/Login';
import Register from './components/Register';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import OrderProcessingPage from './pages/OrderProcessingPage';
import WaitlistSuccess from './pages/WaitlistSuccess';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { AuthProvider, useAuth } from './context/AuthContext';


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function AppRoutes() {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  return (
    <Routes>
      {!isLoggedIn ? (
        <>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/waitlist-success" element={<WaitlistSuccess />} />
          <Route path="*" element={<Navigate to="/" />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate to="/cart" replace />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order" element={<OrderHistoryPage />} />
          <Route path="/download" element={<Download />} />
          <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
          <Route path="/order-processing" element={<OrderProcessingPage />} />
          <Route path="/waitlist-success" element={<WaitlistSuccess />} />
          <Route path="*" element={<Navigate to="/cart" />} />
        </>
      )}
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Elements stripe={stripePromise}>
        <Router>
          <div className="flex flex-col min-h-screen">
            <AppHeader />
            <main className="flex-grow">
              <AppRoutes />
            </main>
            <Footer />
          </div>
        </Router>
      </Elements>
    </AuthProvider>
  );
}

function AppHeader() {
  const { isLoggedIn, logout } = useAuth();
  return isLoggedIn ? <UserHeader onLogout={logout} /> : <GuestHeader />;
}

export default App;
